"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitUntilWithTimeout = exports.waitUntil = void 0;

var _waitUntilAction = require("../redux/middleware/waitUntilAction");

const waitUntil = (_ref) => {
  let {
    predicate,
    run
  } = _ref;
  return {
    type: _waitUntilAction.WAIT_UNTIL_ACTION,
    predicate,
    run
  };
};

exports.waitUntil = waitUntil;

const waitUntilWithTimeout = async function waitUntilWithTimeout(dispatch, waitActionArgs) {
  let timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30000;
  let waitDone = false;
  const waitPromise = new Promise(resolve => {
    dispatch(waitUntil(waitActionArgs(resolve)));
  });
  const timeoutPromise = new Promise((resolve, reject) => {
    setTimeout(() => waitDone ? resolve() : reject(new Error('Wait Action timed out')), timeout);
  });
  const result = await Promise.race([waitPromise.then(result => {
    waitDone = true;
    return result;
  }), timeoutPromise]).catch(null);
  return result;
};

exports.waitUntilWithTimeout = waitUntilWithTimeout;